import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import ModalLayout from '../ModalLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default function ResetPasswordModalDisplay(props) {
  const {
    handlePropUpdate,
    handleSubmit,
    toggleModal,
    isOpen,
    email,
    resetRequestPending,
  } = props;

  return (
    <ModalLayout centered isOpen={isOpen} desktopHeight="50vh">
      <ModalHeader
        className="border-bottom-0 px-md-4 pt-md-4 d-flex"
        toggle={toggleModal}
      >
        <div className="d-flex px-md-2">
          <h5 className="modal-title-text">Forgot Password?</h5>
        </div>
        <div className="text-text-light-gray nine-tenth-text d-flex px-md-2">
          Reset your password by inputting your email below. If the email
          exists, the system will generate a new random password and email it to
          the user.
        </div>
      </ModalHeader>
      <ModalBody className="pt-3 px-md-4 text-text-light-gray">
        <div className="form-group">
          <label htmlFor="email" className="modal-inputlabel-text">
            Email
          </label>
          <input
            className="form-control modal-placeholder-text"
            name="email"
            onChange={handlePropUpdate}
            placeholder="Enter email"
            type="text"
            value={email}
          />
        </div>
      </ModalBody>
      <ModalFooter className="border-top-0 px-md-4 pt-md-4">
        <button
          className="btn modal-button-submit px-4 py-1 m-0"
          onClick={handleSubmit}
        >
          {resetRequestPending ? (
            <FontAwesomeIcon icon={faCircleNotch} spin />
          ) : (
            'Reset Password'
          )}
        </button>
      </ModalFooter>
      <style jsx global>{`
        .modal-title {
          width: 100%;
        }
      `}</style>
    </ModalLayout>
  );
}

ResetPasswordModalDisplay.propTypes = {
  handlePropUpdate: PropTypes.func,
  handleSubmit: PropTypes.func,
  toggleModal: PropTypes.func,
  isOpen: PropTypes.bool,
  email: PropTypes.string,
  resetRequestPending: PropTypes.bool,
};
